import React, { useCallback } from 'react'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'

const VideoGallery = React.lazy(() => loadComponent('traiwiss', 'VideoGallery'))

export function VideoGalleryRoute() {
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const onWatch = useCallback(
        (trainingId: string, trainingVideoId: string) => {
            navigate(`/playback/${trainingId}?video=${encodeURIComponent(trainingVideoId)}`)
        },
        [navigate],
    )

    return (
        <RouteContainer wide>
            {!academy ? (
                <GenericNotice
                    title="Keine Akademie ausgewählt"
                    message="Videos gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um die Galerie zu sehen.">
                    <Button variant="contained" onClick={openFlightDeck}>
                        Flight Deck öffnen
                    </Button>
                </GenericNotice>
            ) : (
                <VideoGallery academyId={academy._id} onWatch={onWatch} />
            )}
        </RouteContainer>
    )
}
